export default __webpack_public_path__ + "6a179c37d01372a35aa2ba7327343258.png";